Customer.Ticket ||= {}

class Customer.Ticket.InteractionsView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/interactions']

  events:
    'click #show-more': 'showMore'

  initialize: (@options = {}) ->
    @data = @options
    @ticketView = @data.ticketView
    @ticket = @data.model
    @interactions = @data.model.interactions()
    @userProfileData = @data.userProfileData
    @interactionViews = []
    @interactionOrderViews = []

  render: ->
    @$el.html(@template(model: @ticket))
    @

  renderInteractions: (interactions) ->
    @interactionViews = []
    @$el.find('#conversation').children().not('#show-more, #show-more-loading').remove()
    @renderMore(interactions)
    @$el.find('#show-more').toggle(@_hasMore())

  buildInteractionsOrder: (interactions) =>
    _.map(interactions, (iv) =>
      @interactionOrderViews.push ({"externalId":"external-id-" + iv.uniqueId(), "created_at": iv.created_at()})
    )
    @interactionOrderViews = _.sortBy(@interactionOrderViews, (iov) => iov.created_at)

  renderMore: (interactions) ->
    @$el.find('#show-more-loading').hide()
    newInteractions = @_insertMoreInteractions(interactions)
    @buildInteractionsOrder(interactions)
    newInteractions = @_removeDuplicateInteractionView(newInteractions)
    newInteractionsToRender = _.map(newInteractions, (newInteraction) =>
      return newInteraction.render().el
    )
    $(newInteractionsToRender).insertAfter(@$el.find('#show-more-loading'))
    @$el.find('#show-more').toggle(@_hasMore())
    Backbone.trigger('interactions:finished_loading')

  renderNew: (interactions) =>
    return if interactions.length == 0
    newInteractions = @_insertMoreInteractions(interactions)
    return if newInteractions.length == 0
    @buildInteractionsOrder(interactions)
    _.map(newInteractions, (newInteraction) =>
      @renderInteractionInPosition(newInteraction)
    )

  renderInteractionInPosition: (newInteraction) ->
    renderedNewInteraction = newInteraction.render().el

    if newInteraction.model
      if newInteraction.model.get('is_response_from_client') && !newInteraction.model.get('responseInteraction')
        @_renderBrandContent(newInteraction, renderedNewInteraction)
      else
        @_renderInOrder(newInteraction, renderedNewInteraction)
    else
      @_appendToEnd(renderedNewInteraction)


  _renderInOrder: (interactionView, interactionHTML) ->
    interactionDate = new Date(interactionView.model.created_at()).getTime()
    nextInteraction = _.first(_.filter(@interactionOrderViews, (item) ->
      itemDate = new Date(item.created_at).getTime()
      itemDate > interactionDate
    ))

    if nextInteraction && !@_hasSameExternalID(nextInteraction, interactionView)
      @_insertBefore(interactionHTML, nextInteraction)
    else
      @_appendToEnd(interactionHTML)

  _renderBrandContent: (interactionView, interactionHTML) ->
    _this = @
    responseInteractionView = _.find(@_filteredInteractions(), (view) ->
      view.model.get('responseInteraction') && _this._hasSameContentID(view, interactionView)
    )
    if responseInteractionView
      @_replace(interactionHTML, responseInteractionView)
    else
      @_renderInOrder(interactionView, interactionHTML)

  _hasSameExternalID: (interactionData, interactionView) ->
    interactionData.externalId == interactionView.externalIdClass()

  _hasSameContentID: (interactionView, anotherInteractionView) ->
    @_contentID(interactionView) == @_contentID(anotherInteractionView)

  _contentID: (interactionView) ->
    interactionData = interactionView.model.interaction()?.interaction
    if interactionData
      interactionData.content_id.toString()
    else
      interactionView.model.externalId().toString()

  _appendToEnd: (interactionHTML) ->
    $(interactionHTML).appendTo(@$el.find('#conversation'))

  _insertBefore: (interactionHTML, nextInteraction) ->
    interactionContainer = @$el.find('.' + nextInteraction.externalId)
    if interactionContainer.length > 0
      $(interactionHTML).insertBefore(interactionContainer)
    else
      @_appendToEnd(interactionHTML)

  _replace: (interactionHTML, replacedInteractionView) ->
    selector = '.' + replacedInteractionView.externalIdClass()
    interactionContainer = @$el.find(selector)
    @ticket._removeResponseInteractionsFromDialogue([replacedInteractionView.model])
    dialogue = @ticket.get('dialogue')
    dialogue.interaction_count = dialogue.interactions.length
    if interactionContainer.length > 0
      $(interactionHTML).replaceAll(selector)
    else
      @_appendToEnd(interactionHTML)

  renderNewResponse: (interaction) ->
    @renderNew([interaction])

  reprocessPreviousInteractions: (newViews) ->
# New views could be a status change event or even a note,
# do not reprocess interactions in those cases
    newInteractionViews = @_filterInteractionViews(newViews)
    if newInteractionViews.length != 0
      @_hideCutTicketButton()

  _hideCutTicketButton: ->
    interactions = @_filteredInteractions()
    if interactions.length != 0
      lastBrandInteraction = interactions.length - 1
      for i in [0..(interactions.length - 1)]
        lastBrandInteraction = i if interactions[i] && interactions[i].isBrandContent()
      for i in [lastBrandInteraction..0]
        interactions[i].disableCutTicketButton() if lastBrandInteraction >= i || !interactions[i].canCut()

  _filteredInteractions: ->
    @_filterInteractionViews(@interactionViews)

  _filterInteractionViews: (views) ->
    _.select(views, (view) =>
      view.viewType == 'interaction'
    )

  _insertMoreInteractions: (interactions) ->
    newInteractionViews = []
    if @_startingInteractionAlreadyRendered(this.interactionViews)
      lastOngoingInteractionView = @_lastOngoingInteractionView(this.interactionViews)
      if lastOngoingInteractionView
        lastOngoingInteractionView._markAsNotTheLastOngoingSurvey()
        model = lastOngoingInteractionView.model
        lastOngoingInteractionView.remove()
        newInteractionViews.push(@_interactionViewsToRender([model])[0])
    newInteractionViews = newInteractionViews.concat(@_interactionViewsToRender(interactions))
    @interactionViews = @interactionViews.concat(newInteractionViews)
    @reprocessPreviousInteractions(newInteractionViews)
    newInteractionViews

  _startingInteractionAlreadyRendered: (interactionsView) =>
    filtered = _.filter interactionsView, (interactionView) =>
      interactionView._isSurveyStartingInteraction && interactionView._isSurveyStartingInteraction(interactionView.model)
    filtered.length > 0

  _lastOngoingInteractionView: (interactionsView) =>
    lastOngoingInteraction = _.filter(interactionsView, (interactionView) => interactionView._isLastOngoingSurveyInteraction(interactionView.model))
    lastOngoingInteraction[0]

  _interactionViewsToRender: (interactions) ->
    if @model.groupType() != 'instagramapi' && @_interactionsParentIsContext() # TODO: hotfix because IG has no context contents yet
      parentInteraction = @_createParentInteractionView(interactions.shift())
      @listenTo(parentInteraction, 'clicked:user', @onClickUser)
    interactionViews = @_activeInteractionViewsToRender(interactions)
    interactionViews.unshift(parentInteraction) if parentInteraction?
    interactionViews

  _activeInteractionViewsToRender: (interactions) ->
    _.map interactions, (interaction) =>
      switch interaction.viewType
        when 'interaction' then @_interactionViewFrom interaction
        when 'note' then @_noteViewFrom interaction
        when 'visible_event' then @_eventViewForm interaction
        when 'status_event' then @_statusEventViewFrom interaction

  _renderedActiveInteractions: (interactions) ->
    _.map(@_activeInteractionViewsToRender(interactions), (iv) => iv.render().el)

  _interactionViewFrom: (interaction) ->
    interactionView = @_createInteractionView(interaction)
    @listenTo(interactionView, 'clicked:user', @onClickUser)
    @listenTo(interactionView, 'ticket:tab:closeRequired', @_closeTicketTab)
    interactionView

  _noteViewFrom: (interaction) ->
    new Customer.Dashboard.NoteView
      model: interaction
      account_users: @data.account_users

  _eventViewForm: (interaction) ->
    switch interaction.attributes.event_type
      when 'Ticket cut' then event_view = new Customer.Dashboard.CutTicketEventView(model: interaction)
      else event_view = new Customer.Dashboard.TicketEventView(model: interaction)
    event_view

  _statusEventViewFrom: (interaction) ->
    new Customer.Ticket.StatusChangeBox
      event: interaction

  _createInteractionView: (interaction) ->
    if interaction.subType() == 'webchat-start'
      new Customer.Ticket.WebchatStartInteractionView @_interactionViewParams(interaction)
    else if interaction.get('isChild') && !@ticketView.model.isByUser()
      @_createChildInteractionView(interaction)
    else
      new Customer.Ticket.InteractionView @_interactionViewParams(interaction)

  _createChildInteractionView: (interaction) ->
    new Customer.Ticket.ChildInteractionView @_childInteractionViewParams(interaction)

  _childInteractionViewParams: (interaction) ->
    model: interaction
    parentInteraction: interaction.get('parentInteraction')
    ticketView: @ticketView
    socialAccounts: @options.socialAccounts
    interactionVisualizationDefault: @options.interaction_visualization_default

  _interactionViewParams: (interaction) ->
    model: interaction
    interactionsView: @
    responseTemplates: @data.responseTemplates
    socialAccounts: @options.socialAccounts
    enabled_email_social_accounts: @options.enabled_incoming_email_social_accounts
    interactionVisualizationDefault: @options.interaction_visualization_default
    privateInteractionOnPublicContent: interaction.privateInteractionOnPublicContent
    interactionType: interaction.get('interaction_type')
    userProfileData: @userProfileData

  _createParentInteractionView: (interaction) ->
    new Customer.Ticket.ContextInteractionView(
      model: interaction,
      interactionsView: @
    )

  showMore: =>
    @_keepCustomerSessionAlive()
    @$el.find('#show-more').hide()
    @$el.find('#show-more-loading').show()
    @_showMore()

  updateVisibilityByPrivacy: (privacy) ->
    _.each(@interactionViews, (iv) =>
      iv.updateVisibilityByPrivacy(privacy) if iv.updateVisibilityByPrivacy?
    )

  getTicket: ->
    @ticket

  onClickUser: (interaction) ->
    @trigger('clicked:user', interaction)

  duplicate: (interactionId) ->
    params = {conversation_id: @model.get('id'), social_content_id: @model.get('id'), interaction_id: interactionId}
    @ticket.duplicate(params)

  _hasMore: ->
    @ticket.hasMore()

  _showMore: ->
    @ticket.loadMore()

  _interactionsParentIsContext: ->
    @ticket.dialogue().interactions_parent_is_context

  closeAllResponseBoxes: ->
    _.each(@interactionViews, (iv) -> iv.closeResponseBox() if iv.closeResponseBox?)

  onDetach: ->
    _.each(@interactionViews, (interactionView) ->
      interactionView.onDetach() if interactionView.onDetach?)

  onAttach: ->
    _.each(@interactionViews, (interactionView) ->
      interactionView.onAttach() if interactionView.onAttach?)

  removeAllReplyButtons: ->
    _.each(@interactionViews, (iv) -> iv.removeReplyButton() if iv.removeReplyButton?)

  removeAllCutTicketButtons: ->
    _.each(@interactionViews, (iv) -> iv.removeCutTicketButton() if iv.removeCutTicketButton?)

  disableAllCutTicketButtons: ->
    _.each(@interactionViews, (iv) ->
      iv.disableCutTicketBtn() if iv.disableCutTicketBtn? )

  enableAllCutTicketButtons: ->
    _.each(@interactionViews, (iv) ->
      iv.enableCutTicketBtn() if iv.enableCutTicketBtn? )

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _closeTicketTab: =>
    @trigger('ticket:tab:closeRequired')

  changeShowStatusEvents: (showEvents) =>
    @$el.find('.status-change-box').toggleClass('d-none', !showEvents)

  _removeDuplicateInteractionView: (interactionViews) ->
    seenIds = new Set()
    uniqueInteractionViews = []

    for interactionView in interactionViews
      if interactionView.viewType == 'interaction'
        id = interactionView.externalIdClass()
        unless seenIds.has(id)
          seenIds.add(id)
          uniqueInteractionViews.push(interactionView)
      else
        uniqueInteractionViews.push(interactionView)

    uniqueInteractionViews